import { render, staticRenderFns } from "./EditCandidato.vue?vue&type=template&id=02506a8e"
import script from "./EditCandidato.vue?vue&type=script&lang=js"
export * from "./EditCandidato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports